export function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
export { _is_native_function as _ };
